import React from 'react';

// Constants:
const CONSTANTS = {
    AMAZON_TAM: `window.apstag = { init: function () { window.apstag._Q.push(['i', arguments]); }, fetchBids: function () { window.apstag._Q.push(['f', arguments]); }, setDisplayBids: function () {}, targetingKeys: function () { return []; }, _Q: [], };`,
    DEFINE_ADSENSE_QUEUE: "(function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(arguments)},g[o]['t']=1*new Date})(window,'_googCsa');",
};
const getAdvMetadata = () => ({
    'google-adsense-account': 'sites-6949535538200610',
});
// Default configuration
const defaultConfig = {
    includeOw: false,
    includePrebid: false,
    includeTam: false,
    includeAdSense: false,
    publicPath: '',
};
function AdvScripts({ config = defaultConfig, Script, }) {
    const buildDate = '1749550934';
    const { includeOw, includeTam, includeAdSense, includePrebid, publicPath = '', owProfileID, } = config;
    const renderScript = (id, content) => (React.createElement(Script, { key: id, id: id, strategy: "beforeInteractive" }, content));
    const renderExternalScript = (src, id) => (React.createElement(Script, { key: src, src: src, strategy: "beforeInteractive", id: id }));
    return (React.createElement(React.Fragment, null,
        renderExternalScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js'),
        renderExternalScript(`${publicPath}/lira-sdk.${buildDate}.js`),
        includeTam && (React.createElement(React.Fragment, null,
            renderScript('tam-config', CONSTANTS.AMAZON_TAM),
            renderExternalScript('https://c.amazon-adsystem.com/aax2/apstag.js'))),
        includeOw &&
            owProfileID &&
            renderExternalScript(`https://ads.pubmatic.com/AdServer/js/pwt/81997/${owProfileID}/pwt.js`),
        includePrebid &&
            renderExternalScript(`https://assets.subito.it/static/js/prebid-library.js?v=9380`),
        includeAdSense && (React.createElement(React.Fragment, null,
            renderScript('adsense-config', CONSTANTS.DEFINE_ADSENSE_QUEUE),
            renderExternalScript('https://www.google.com/adsense/search/ads.js')))));
}
const generateMetadata = () => Object.entries(getAdvMetadata()).map(([key, value]) => (React.createElement("meta", { key: key, name: key, content: value })));

export { AdvScripts, generateMetadata, getAdvMetadata };
//# sourceMappingURL=index.js.map
